module.exports = __webpack_public_path__ + "img/17.efed92d0.jpg";